import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FeatherIconNames} from 'feather-icons';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';
import {LoadingComponent} from '../loading/loading.component';

@Component({
  selector: 'app-button',
  imports: [
    TranslateModule,
    CommonModule,
    FeatherPipe,
    LoadingComponent
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() color: 'primary' | 'secondary' | 'danger' | 'success' | 'warning' | 'info' | 'light' | 'dark' | 'neutral' = 'primary';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() rounded: 'none' | 'sm' | 'md' | 'lg' | 'full' = 'md';
  @Output() buttonClick = new EventEmitter<MouseEvent>();
  @Input() icon: FeatherIconNames | null = null;
  @Input() iconSize: number = 16;

  onClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.buttonClick.emit(event);
    }
  }
}
